import { SignUp } from '@expertli/features/auth/components';
import SimpleLayout from '@expertli/layouts/simple-layout';

function Page() {
  return <SignUp mode="sign-up" />;
}

Page.getLayout = (page) => (
  <SimpleLayout pageLink={{ text: 'Log in', href: '/auth/log-in' }}>{page}</SimpleLayout>
);

export default Page;
